module.exports = __webpack_public_path__ + "static/media/4.b6b74416.png";